'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const Formatters=require('../../../../dist-es6/client/formatters');let

GraphGuideLinesDirective=class GraphGuideLinesDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['plotArea','verticalAxis','horizontalAxis','timezone'];
}

get textBindings(){
return[];
}

get controller(){
return GraphGuideLinesDirectiveController;
}};let


GraphGuideLinesDirectiveController=class GraphGuideLinesDirectiveController{
static get $inject(){return['$scope','$element','$timeout','$window','dateService']}

constructor($scope,$element,$timeout,$window,dateService){
this._$scope=$scope;
this._dateService=dateService;

$scope.$watch('controller.plotArea',()=>{
if(_.exists(this.plotArea)){
this.plotArea.registerPlotter(this);
}
});
}

get _scalesValid(){
return(
_.exists(this.horizontalAxis)&&
_.exists(this.horizontalAxis.scale)&&
_.exists(this.verticalAxis)&&
_.exists(this.verticalAxis.scale));
}

redraw(){
if(!this._scalesValid){
return;
}

let dayBreakTicks=d3.select(this.plotArea.svgElement).insert('g').attr({
class:'day-break-lines',
transform:`translate(0, ${this.plotArea.dimensions.height})`}).
call(this._drawDayBreakLines());

dayBreakTicks.
selectAll('text').
style({"text-anchor":'start'}).
each(function(){
this.innerHTML=d3.select(this).
text().
split(' ').
map((t,i)=>`<tspan${t===_todayText?' class="today"':''}>${i===0?t.toUpperCase():t}</tspan>`).
join(' ');
});

let fatigueGroup=d3.select(this.plotArea.svgElement).append('g').attr({
class:'fatigue-guide-lines',
transform:`translate(${this.plotArea.dimensions.width}, 0)`});


let fatigueTicks=fatigueGroup.call(this._drawFatigueGuideLines());
d3.select(_.first(fatigueTicks.selectAll('.tick')[0])).attr('visibility','hidden');

fatigueGroup.append('text').
attr({
class:'axis-label',
transform:'rotate(-90)',
y:-this.plotArea.graphAreaDimensions.width,
x:-this.plotArea.graphAreaDimensions.height,
dy:'-30px',
"text-anchor":'start'}).

text('Fatigue');
}
_drawDayBreakLines(){
const zonedDayIntervals=this.horizontalAxis.domain.getSpanningIntervals('days',1,this.timezone);
const today=zonedDayIntervals.find(i=>i.contains(this._dateService.now()));

return d3.svg.axis().
scale(this.horizontalAxis.roundedScale).
orient('top').
tickValues(zonedDayIntervals.map(i=>i.start)).
tickFormat(time=>_.exists(today)&&today.start===time?
_todayText:
Formatters.formatInLocale(time,'ddd MMM DD',this.timezone,{displayTimeZone:!1})).
innerTickSize(this.plotArea.graphAreaDimensions.height).
outerTickSize(0);
}

_drawFatigueGuideLines(){
return d3.svg.axis().
scale(this.verticalAxis.scale).
orient('left').
ticks(5).
innerTickSize(this.plotArea.graphAreaDimensions.width).
outerTickSize(0);
}};


const _todayText='Today';

module.exports=GraphGuideLinesDirective;
//# sourceMappingURL=graphGuideLinesDirective.js.map
